'use client'

import { ChevronRight, ShieldCheck } from 'lucide-react'

import { AppLink } from '@/shared/lib/router'

import { Card, CardBody, CardHeader, CardTitle } from '@/shared/ui/Card'

// Seção permanente de direitos do titular (LGPD) na Central de Ajuda — visível
// mesmo sem posts no mural. Explica os direitos e leva a "Meus Dados".
export function LgpdRightsCard() {
  return (
    <Card variant="default">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <ShieldCheck className="size-5 text-primary" aria-hidden />
          Seus direitos (LGPD)
        </CardTitle>
      </CardHeader>
      <CardBody className="flex flex-col gap-3 text-sm">
        <p className="text-muted-foreground">
          Você pode acessar, corrigir e solicitar a exclusão dos seus dados
          pessoais a qualquer momento.
        </p>
        <AppLink
          href="/meus-dados"
          className="group flex items-center gap-3 rounded-xl border border-border bg-white p-3 transition-colors hover:border-primary hover:bg-accent"
        >
          <span className="flex min-w-0 flex-1 flex-col">
            <span className="font-semibold">Meus Dados</span>
            <span className="text-xs text-muted-foreground">
              Ver e exportar seus dados (JSON ou PDF)
            </span>
          </span>
          <ChevronRight className="size-4 shrink-0 transition-transform group-hover:translate-x-0.5" aria-hidden />
        </AppLink>
        <p className="text-xs text-muted-foreground">
          Para solicitações via responsável ou atendimento, use o canal de
          atendimento LGPD do SEBRAE/RN.
        </p>
      </CardBody>
    </Card>
  )
}
